





































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { CreateElement } from "vue";
import _ from "@/boot/lodash";

// Mixins
import CProdMixin from "@/mixins/cProdMixin";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import {
  IContractProduct,
  IContractProductCondition
} from "@/models/contracts";
import { IProvisionConfigurationFunction } from "@/models/provisioning";
import RequestPromises from "@/mixins/requestPromises";
import { IRoute } from "@/models/routes";

@Component({
  components: {
    "cprod-image": () =>
      import("@/components/app/global/contractProducts/cProdImage.vue"),
    "product-image": () =>
      import("@/components/app/global/products/productImage.vue")
  }
})
export default class CProdRowWithFuncs extends Mixins(
  CProdMixin,
  RequestPromises
) {
  // Props

  @Prop({ default: null })
  public cProd!: IContractProduct;

  @Prop({ default: "3rem" })
  public imgSize!: string;

  @Prop({ default: false })
  public isLoading!: boolean;

  // Data

  public functions: IProvisionConfigurationFunction[] | null = null;
  public isProcessing = false;

  // Computed

  public get hasProvisionBlueprint() {
    return !!this.cProd?.product?.provision_blueprint_id;
  }

  public get highlightedFunc() {
    return _.first(_.filter(this.functions, ["highlight", true]));
  }

  // Methods

  public async created() {
    if (!this.cProd) return;
    this.functions = await this.getProvisionFunctions();
  }

  public getProvisionFunctions() {
    if (!this.hasProvisionBlueprint) return [];
    return this.$store.dispatch(
      `data/${DataModules.PROVISIONING_CONTRACT_PRODUCTS}/listContractProductFunctions`,
      {
        contractId: this.cProd.contract_id,
        productId: this.cProd.id,
        params: { order: "-highlight,order" },
        storeData: false,
        returnData: true,
        vm: this
      }
    );
  }

  public async executeFunction(
    cProdProvFunction: IProvisionConfigurationFunction
  ) {
    try {
      this.isProcessing = true;
      await this.$store.dispatch(
        `data/${DataModules.PROVISIONING_FUNCTIONS}/executeFunction`,
        {
          provFunction: cProdProvFunction,
          contractId: this.cProd.contract_id,
          productId: this.cProd.id,
          vm: this
        }
      );
    } finally {
      this.isProcessing = false;
    }
  }

  public getSummary(cProd: IContractProduct) {
    const condition = this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/conditionSummary`
    ](cProd) as IContractProductCondition;
    return {
      render: (h: CreateElement) => {
        if (!condition) return h("span", cProd.status?.name);
        return h(condition.summary, {
          class: ["is-size-7", condition.type.replace("is-", "has-text-")]
        });
      }
    };
  }

  public getStatusIcon(cProd: IContractProduct) {
    const condition = this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/conditionSummary`
    ](cProd) as IContractProductCondition;

    return {
      render: (h: CreateElement) => {
        return h("div", {
          class: `u-cprod-status ${condition.type.replace(
            "is-",
            "has-background-"
          ) || "has-background-grey"}`
        });
      }
    };
  }

  // Computed

  public get showSkeletons() {
    return _.isNull(this.cProd);
  }

  public get cProdRoute() {
    return this.$store.getters[`data/${DataModules.CONTRACTS_PRODUCTS}/route`](
      this.cProd
    )?.to as IRoute["to"];
  }

  public get cProdBillingRoute() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/routeToBilling`
    ](this.cProd)?.to as IRoute["to"];
  }

  public get entity() {
    return this.$store.getters[`data/${DataModules.CONTRACTS_PRODUCTS}/entity`](
      this.cProd
    );
  }
}
